import RxDBStorageProvider from './RxDBProvider';

export { default as RxDBCreatorIdWatcher } from './RxDBCreatorIdWatcher';
export default RxDBStorageProvider;
